import { Component } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { QuestionTypeConfig } from 'src/app/shared/interfaces/process-config.interface';

@Component({
  selector: 'app-configuration-boolean-values',
  templateUrl: './configuration-boolean-values.page.html'
})
export class ConfigurationBooleanValuesPage {

  public config: QuestionTypeConfig;
  public language: string;

  constructor(
    public _modalController: ModalController,
    private _navParams: NavParams
  ) {
    this.config = this._navParams.get('typeConfig');
    this.language = this._navParams.get('language');

    if (!this.config.possibleValuesGlobalized) {
      this.config.possibleValuesGlobalized = {
        'en-US': ['', ''],
        'es-ES': ['', ''],
        'pt-BR': ['', '']
      };
    }
  }

  public dismiss(): void {
    this._modalController.dismiss();
  }

  public save(): void {
    this._modalController.dismiss();
  }

}
